__webpack_require__.p = "https://dashboard-iq.com/";